/*
 *******************************************************************************
 *
 *  Filename:   /redux/slices/patients.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Patients redux reducer
 *
 *  Author:     Norman J. Nolasco [ Archetact Software ]
 *
 *  Created:    Sunday, January 28, 2024 - 11:28 PM (CST)
 *
 *  Notes:
 *
 *  Revisions:
 *              2024/01/28  NJN Initial Build
 *
 *  Copyright (c) 2024 - Archetact Software - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import { createSlice } from "@reduxjs/toolkit";
import { updateFieldReducer, updateTypedFieldReducer } from "@/redux/reducerHelpers";

const lastweek = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000);
const today = new Date();
const tomorrow = new Date(Date.now() + 24 * 60 * 60 * 1000);

const initialState = {
  patientid: 0,
  companyid: 0,
  providerid: 0,
  error: null,
  defaultToolPanel: "filter",
  patientorder: "LASTNAME ASC",
  search: "",
  columnState: [],
  casesColumnState: [],
  startDate: new Date(Date.UTC(lastweek.getUTCFullYear(), lastweek.getUTCMonth(), lastweek.getUTCDate())).toISOString(), // "2025-09-14T00:00:00.000Z"
  endDate: new Date(Date.UTC(tomorrow.getUTCFullYear(), tomorrow.getUTCMonth(), tomorrow.getUTCDate())).toISOString(), // "2025-09-15T00:00:00.000Z"
};

const intFields = ["patientid", "companyid", "providerid"];

export const sessionSlice = createSlice({
  name: "patients",
  initialState,
  reducers: {
    updatePatientID: (state, action) => updateFieldReducer(state, action, "patientid"),
    updateCompanyID: (state, action) => updateFieldReducer(state, action, "companyid"),
    updateProviderID: (state, action) => updateFieldReducer(state, action, "providerid"),
    updateDefaultToolPanel: (state, action) => updateFieldReducer(state, action, "defaultToolPanel"),
    updateColumnState: (state, action) => updateFieldReducer(state, action, "columnState"),
    updateCasesColumnState: (state, action) => updateFieldReducer(state, action, "casesColumnState"),
    updateStartDate: (state, action) => updateTypedFieldReducer(state, action, "startDate", initialState),
    updateEndDate: (state, action) => updateTypedFieldReducer(state, action, "endDate", initialState),
  },
});

export const {
  updatePatientID,
  updateCompanyID,
  updateAuthorID,
  updateDefaultToolPanel,
  updateColumnState,
  updateCasesColumnState,
  updateStartDate,
  updateEndDate,
} = sessionSlice.actions;

export default sessionSlice.reducer;
